import React, { useState } from 'react';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import { syncUserToFirestore } from '../services/userService';
import './AuthForm.css';

const AuthForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const handleSignUp = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      // Sync user to Firestore users collection
      await syncUserToFirestore(userCredential.user);
    } catch (error) {
      setError(error.message);
    }
    
    setIsLoading(false);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      // Sync user to Firestore users collection (updates lastSeen)
      await syncUserToFirestore(userCredential.user);
    } catch (error) {
      setError(error.message);
    }
    
    setIsLoading(false);
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    setIsLoading(true);
    setError('');
    setMessage('');
    
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage('Password reset email sent! Check your inbox.');
      setShowForgotPassword(false);
    } catch (error) {
      setError(error.message);
    }
    
    setIsLoading(false);
  };

  if (showForgotPassword) {
    return (
      <div className="auth-container">
        <div className="auth-form">
          <h1 className="auth-title">Reset Password</h1>
          <form onSubmit={handleForgotPassword}>
            <div className="form-group">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>
            
            {error && <div className="error-message">{error}</div>}
            {message && <div className="success-message">{message}</div>}
            
            <button type="submit" className="auth-button primary" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Reset Email'}
            </button>
            
            <button 
              type="button" 
              className="link-button"
              onClick={() => setShowForgotPassword(false)}
              disabled={isLoading}
            >
              Back to Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h1 className="auth-title">Welcome</h1>
        <p className="auth-subtitle">Sign in to your account or create a new one</p>
        
        <form>
          <div className="form-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          
          <div className="form-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
          
          <div className="button-group">
            <button 
              type="submit" 
              onClick={handleSignIn}
              className="auth-button primary"
              disabled={isLoading}
            >
              {isLoading ? 'Signing In...' : 'Sign In'}
            </button>
            
            <button 
              type="submit" 
              onClick={handleSignUp}
              className="auth-button secondary"
              disabled={isLoading}
            >
              {isLoading ? 'Signing Up...' : 'Sign Up'}
            </button>
          </div>
          
          <button 
            type="button" 
            className="link-button"
            onClick={() => setShowForgotPassword(true)}
            disabled={isLoading}
          >
            Forgot Password?
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthForm;